import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from "react-i18next";
import './../css/header.css';
import myicon from './../images/icon.png';

const Header = () => {
  const { i18n } = useTranslation("profile");
  const currentLang = i18n.language;

  const handleNavItemClick = () => {
    const navbarCollapse = document.getElementById("Navber");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, { toggle: false });
      bsCollapse.hide();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary header fixed-top" data-bs-theme="">
      <div className="container-fluid">
        <HashLink to="/" className="navbar-brand dflex dflexac" onClick={handleNavItemClick}>
          <img src={myicon} className="img-fluid img-icon" alt="" />
          <span>Yodai Suzuki</span>
        </HashLink>

        <button
          type="button"
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#Navber"
          aria-controls="Navber"
          aria-expanded="false"
          aria-label="ナビゲーションの切替"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="Navber">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 dflexac">
            <li className="nav-link">
              <HashLink to="/publications" className="dropdown-item" onClick={handleNavItemClick}>
                Publications
              </HashLink>
            </li>
            <span className="in-flex-spacer"></span>
            <div className="dflex dflexac">
              <button
                onClick={() => i18n.changeLanguage("ja")}
                className={`toggle-lang-button font-ms lang-ja ${currentLang === "ja" ? "lang-active" : ""}`}
              >
                日本語
              </button>
              <span className="lang-slash font-ms">/</span>
              <button
                onClick={() => i18n.changeLanguage("en")}
                className={`toggle-lang-button font-ms ${currentLang === "en" ? "lang-active" : ""}`}
              >
                English
              </button>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
